export const LOCALE_US_EN = 'us/en'
export const LOCALE_GB_EN = 'gb/en'
export const LOCALE_GEO = 'geo'

export const LOCALES_USING_IMPERIAL_SYSTEM = [LOCALE_US_EN, LOCALE_GEO]
export const ALLOWED_REGIONS = [LOCALE_US_EN, LOCALE_GB_EN]
